import {CourierButton} from "./CourierButton";
import {Loader} from "./Loader";

require('../../sass/components/_carrierPrice.scss');

export const CarrierPrice = {
    name: 'CarrierPrice',
    components: {
        CourierButton,
        Loader
    },
    props: {
        price: Number,
        code: String,
        id: Number,
        warning: Boolean,
        domestic: Boolean,
        isSelected: Boolean,
        isLoading: Boolean,
        isSelectable: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'big'
        }
    },
    filter: {
        formatPrice(price) {
            return (price / 100).toFixed(2)
        }
    },
    computed: {
        classes() {
            let tooltipPosition = '';
            if (['dhl', 'ups'].includes(this.code)) {
                tooltipPosition = '--bottom';
            }

            if (this.warning){
                this.isSelectable = false;
                this.isSelected = false;
                return [
                    'carrier-price',
                    this.size && `carrier-price--${this.size}`,
                    this.isSelectable && 'carrier-price--selectable',
                    'carrier-price--warning',
                    'carrier-price--not-available' + tooltipPosition
                ];
            }

            return [
                'carrier-price',
                this.size && `carrier-price--${this.size}`,
                this.formattedPrice !== 'brak oferty' && 'carrier-price--selectable',
                this.isSelected && 'carrier-price--selected',
                this.warning && 'carrier-price--warning',
                !this.isAvailable && 'carrier-price--not-available'
            ];
        },
        tooltipClass() {
            if (this.code === 'ups') {
                return 'tooltiptext_bottom';
            }
            return 'tooltiptext_top';
        },
        formattedPrice() {
            if (this.warning) {
                return (this.price / 100).toFixed(2) + ' zł';
            }
            if (!this.isAvailable) {
                return 'brak oferty';
            }
            return (this.price / 100).toFixed(2) + ' zł';
        },
        isAvailable() {
            if (this.warning) {
                return false;
            }
            return !isNaN(this.price);
        },
        buttonSize() {
            if (this.size === 'big') {
                return 'medium';
            }
            if (this.size === 'small') {
                return 'normal';
            }
        },
        isDomestic() {
            return this.domestic;
        }
    },
    methods: {
        onSelect() {
            if (this.isSelectable && this.isAvailable) {
                this.$emit('selected', this.code);
            }
        }
    },
    template: `
        <div @click="onSelect" :class="classes">
            <CourierButton :code="code" :size="buttonSize" :is-available="isAvailable" :is-domestic="isDomestic" class="carrier-price__carrier courier-button--no-radius" />
            <Loader v-if="isLoading" class="carrier-price__loader"/>
            <span v-if="warning && !isLoading" class="carrier-price--warning-icon">
            </span>
            <span v-if="warning && !isLoading" :class="tooltipClass">Koszt naliczany przez firmę kurierską dla przesyłki wydanej do transportu mimo braku oferty</span>
            <span class="carrier-price__price" v-if="!isLoading">{{ formattedPrice }}</span>
        </div>
    `
};
